var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-comment-input"},[_c('quill-editor',{ref:"quillEditor",staticClass:"comment-editor",attrs:{"content":_vm.formValue,"editor":_vm.editor,"options":{
    placeholder: '请输入评论',
    modules: {
      toolbar: []
    }
  }},on:{"change":function($event){return _vm.onChange($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }